import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../stores/authStore';
import { LoadingScreen } from '../ui/LoadingSpinner';

const ProtectedRoute = ({ children, requireAuth = true, redirectTo = '/login' }) => {
  const { isAuthenticated, isInitialized, isLoading } = useAuth();
  const location = useLocation();

  // Show loading while auth is being initialized
  if (!isInitialized || isLoading) {
    return <LoadingScreen message="Checking authentication..." />;
  }

  // If route requires auth but user is not authenticated
  if (requireAuth && !isAuthenticated) {
    return (
      <Navigate 
        to={redirectTo} 
        state={{ from: location }} 
        replace 
      />
    );
  }

  // If route requires no auth but user is authenticated (e.g., login page)
  // Only redirect if we're not already on the target page to prevent infinite loops
  if (!requireAuth && isAuthenticated) {
    const { user } = useAuth.getState();
    const isCA = user?.role === 'ca' || user?.businessType === 'ca_firm';
    const target = isCA ? '/ca/dashboard' : '/app/dashboard';
    
    if (location.pathname !== target) {
      return <Navigate to={target} replace />;
    }
  }

  // Role-based access control
  const { user } = useAuth.getState();
  const isCA = user?.role === 'ca' || user?.businessType === 'ca_firm';
  const isVendorRoute = location.pathname.startsWith('/app/');
  const isCARoute = location.pathname.startsWith('/ca/');

  // Prevent CA from accessing vendor dashboard
  if (isCA && isVendorRoute) {
    return <Navigate to="/ca/dashboard" replace />;
  }

  // Prevent Vendor from accessing CA dashboard
  if (!isCA && isCARoute && isAuthenticated) {
    return <Navigate to="/app/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;